module.exports = __webpack_public_path__ + "media/images/down_arrow-53854c5fdf2b2f96ae09764c179ca6c6.png";